import * as Website from '../Config/Website.js';

const FloatCta = () => {
  const float = document.getElementById('js-float');
  const menuButton = document.querySelector('.js-menuButton');
  if (!float && !menuButton) return;

  const mv = document.querySelector('.p-homeMv');
  if (!mv) return;

  const mvBottom = mv.getBoundingClientRect().top + window.scrollY + mv.offsetHeight;

  if (window.scrollY > mvBottom) {
    if (float) float.classList.add('is-act');
    if (menuButton) menuButton.classList.add('is-act');
  } else {
    if (float) float.classList.remove('is-act');
    if (menuButton) menuButton.classList.remove('is-act');
  }
}

export default FloatCta;
